<template>
  <div class="modal sign-modal">
    <div class="overlay" @click="$emit('closeSignIn')" />
    <div class="wrapper">
      <button class="close" @click="$emit('closeSignIn')">
        <img src="@/assets/img/closeNew.svg" alt="close new" srcset="" />
      </button>
      <!-- <div class="modal-header">
        <div class="logo">
          <img src="@/assets/img/logo.svg" alt="logo" srcset="" />
        </div>
      </div> -->

      <div class="modal-content">
        <div class="container">
          <div class="form">
            <div class="form-wrapper">
              <div class="modal-main">
                <div
                  :class="[
                    'form-fields login-content',
                    { hidden: !loginContentVisible },
                  ]"
                >
                  <div class="form-fields-wrapper">
                    <div class="auth-left">
                      <div class="title desc-bottom">
                        <span class="text-white"
                          >{{ $t("Don't have account?") }}
                        </span>
                        <button
                          class="button bordered-white w-130"
                          @click="$emit('openSignUp')"
                        >
                          {{ $t("Sign up") }}
                        </button>
                      </div>
                    </div>
                    <div class="auth-right">
                      <div class="auth-right-wrapper">
                        <div class="title text-white">{{ $t("Sign In") }}</div>
                        <label>
                          <input
                            v-model="email"
                            type="email"
                            :placeholder="$t('email')"
                            autocomplete="username"
                          />
                        </label>
                        <label>
                          <input
                            v-model="pass"
                            type="password"
                            :placeholder="$t('password')"
                          />
                        </label>

                        <div class="cta-container">
                          <button
                            @click="submitLogin"
                            :disabled="loaderIsVisible"
                            class="button w-130 red"
                          >
                            {{ $t("LOGIN") }}
                          </button>
                        </div>
                        <Transition>
                          <div v-if="successMessage" class="desc green">
                            {{ successMessage }}
                          </div>
                        </Transition>
                        <Transition>
                          <div v-if="error" class="error-desc desc red">
                            {{ error }}
                          </div>
                        </Transition>
                        <Transition>
                          <div v-if="showResendOption" class="resend-option">
                            <button
                              class="resend-button button"
                              @click="resendVerificationEmail"
                            >
                              {{ $t("Resend Verification Email") }}
                            </button>
                          </div>
                        </Transition>
                      </div>

                      <div class="auth-right-wrapper">
                        <div class="link-container">
                          <a
                            class="desc link small"
                            @click="switchToforgotPass"
                          >
                            {{ $t("Forgot password?") }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  :class="[
                    'form-fields forgot-pass-content',
                    { hidden: !forgotPassContentVisible },
                  ]"
                >
                  <div class="form-fields-wrapper">
                    <div class="auth-left">
                      <div class="title desc-bottom">
                        <span class="text-white"
                          >{{ $t("Don't have account?") }}
                        </span>
                        <button
                          class="button bordered-white w-130"
                          @click="$emit('openSignUp')"
                        >
                          {{ $t("Sign up") }}
                        </button>
                      </div>
                    </div>

                    <div class="auth-right">
                      <div class="auth-right-wrapper">
                        <div class="title text-white">
                          <b>{{ $t("Forgot password?") }}</b>
                        </div>
                        <label>
                          <input
                            v-model="email"
                            type="email"
                            :placeholder="$t('Email')"
                            autocomplete="username"
                          />
                        </label>
                        <div class="cta-container">
                          <button
                            :disabled="loaderIsVisible"
                            @click="submitForgotPass"
                            class="button w-130 red"
                          >
                            {{ $t("Recover") }}
                          </button>
                        </div>
                        <Transition>
                          <div v-if="successMessage" class="desc green">
                            {{ successMessage }}
                          </div>
                        </Transition>
                        <Transition>
                          <div v-if="error" class="error-desc desc red">
                            {{ error }}
                          </div>
                        </Transition>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginModal",
  props: {
    error: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      required: true,
    },
    loaderIsVisible: {
      type: Boolean,
      required: true,
    },
    showResendOption: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      loginContentVisible: true,
      forgotPassContentVisible: false,
      email: "",
      pass: "",
    };
  },
  mounted() {},
  methods: {
    resendVerificationEmail() {
      this.$emit("resendVerificationEmail", this.email);
    },
    openSignUp() {
      this.$emit("clearError");
      this.$emit("openSignUp");
    },
    switchToforgotPass() {
      this.$emit("hideResendOption");
      this.$emit("clearError");
      setTimeout(() => {
        this.loginContentVisible = false;
        this.forgotPassContentVisible = true;
      }, 100);
    },
    switchToLogin() {
      this.$emit("hideResendOption");
      this.$emit("clearError");
      setTimeout(() => {
        this.forgotPassContentVisible = false;
        this.loginContentVisible = true;
      }, 100);
    },
    submitLogin() {
      let loginData = {
        username: this.email,
        password: this.pass,
      };
      this.$emit("login", loginData);
    },
    submitForgotPass() {
      let data = {
        email: this.email,
      };
      this.$emit("forgotPass", data);
    },
  },
};
</script>

<style scoped lang="scss">
.resend-button {
  width: 100%;
  margin-top: 16px;
}

.container-wrapper {
  border: 1px solid #191919;
  padding: 12px;
  position: relative;
  max-width: 441.6px;
  width: 100%;
}

.modal .container {
  background-color: #191919;
  padding: 32px 59px;
}
.title + label {
  margin-top: 34px;
}
</style>
